module.exports = __webpack_public_path__ + "img/pencil.1aa92838.svg";